import { ActionIcon, Group, Stack, Text } from "@mantine/core";

import { getAvatar } from "../../utils";

import { Dropdown, DropdownProps, TextSerif } from "@/components/elements";
import { IconTrash } from "@/components/icons";
import { FileAttachment } from "@/components/widgets/FileUploader/types";
import { formatFileSize } from "@/components/widgets/FileUploader/utils";

import type { Attachment } from "@/types/attachment";
import type { FC } from "react";

export type AttachmentItemLabels = {
  itemTypePlaceholder?: string;
};

export type AttachmentItemProps = Attachment & {
  disabled?: boolean;
  labels?: AttachmentItemLabels;
  onChange?: (file: Partial<FileAttachment>) => void;
  onDelete?: () => void;
  types?: DropdownProps["data"];
};

const defaultLabels: AttachmentItemLabels = {
  itemTypePlaceholder: "Document type",
};

export const AttachmentItem: FC<AttachmentItemProps> = ({
  disabled = false,
  labels: customLabels,
  mime_type,
  name,
  onChange,
  onDelete,
  path,
  size,
  type,
  types,
}) => {
  const labels = { ...defaultLabels, ...customLabels };
  const maw = 240;

  return (
    <>
      <Group gap="lg" wrap="nowrap" style={{ minWidth: 0, flex: "1 1 180px" }}>
        {getAvatar(mime_type, path)}
        <Stack gap="xs" miw={0} style={{ minWidth: 0, flex: "1 1 100%" }}>
          <Text size="lg" lh={1} title={name} truncate maw={maw} miw={0}>
            {name}
          </Text>
          <TextSerif
            size="sm"
            title={`${formatFileSize(size)} (${mime_type})`}
            truncate
            maw={maw}
            miw={0}
          >
            {formatFileSize(size)} ({mime_type})
          </TextSerif>
        </Stack>
      </Group>
      <Group gap="xl" style={{ flex: "0 0 auto", maxWidth: "100%" }}>
        {types && (
          <Dropdown
            data={types}
            disabled={disabled}
            onChange={(value) => onChange?.({ type: value || undefined })}
            value={type}
            inputProps={{ miw: 180 }}
            placeholder={labels.itemTypePlaceholder}
          />
        )}
        {onDelete && (
          <ActionIcon color="red" variant="light" onClick={onDelete} disabled={disabled}>
            <IconTrash />
          </ActionIcon>
        )}
      </Group>
    </>
  );
};
